import React, { useCallback, useState } from 'react';
import { Button } from 'grab-ui';
import PropTypes from 'prop-types';

const ClickToSeeButton = ({
  hiddenElement,
  children,
  onClick,
  ...buttonProps
}) => {
  const [clicked, setClicked] = useState(false);
  const onButtonClick = useCallback(
    event => {
      setClicked(true);
      if (onClick) {
        onClick(event);
      }
    },
    [setClicked, onClick],
  );

  if (clicked) {
    return hiddenElement;
  }

  return (
    <Button onClick={onButtonClick} {...buttonProps}>
      {children}
    </Button>
  );
};

ClickToSeeButton.propTypes = {
  hiddenElement: PropTypes.node,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

ClickToSeeButton.defaultProps = {
  hiddenElement: undefined,
  children: undefined,
  onClick: undefined,
};

export default ClickToSeeButton;
